import React from "react";

const styles = {
  ap: {
    fontFamily: "'Manrope', sans-serif",
    background: "#f4f4f9",
    width: "100%",
    padding: "60px 60px 0px",
    marginTop: "60px",
  },
  wrap: {
    background: "#ffffff",
    borderRadius: "20px",
    padding: "40px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    color: "#4b5563",
  },
  hero: {
    textAlign: "center",
  },
  heroH1: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: "2.8rem",
    color: "#000000",
    marginBottom: "12px",
    fontWeight: "700",
  },
  heroP: {
    fontSize: "1rem",
    lineHeight: "1.7",
    marginBottom: "6px",
  },
  h2: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: "1.6rem",
    color: "#000000",
    margin: "16px 0 8px 0",
    fontWeight: "700",
  },
  p: {
    fontSize: "0.95rem",
    lineHeight: "1.7",
    marginBottom: "6px",
  },
  ul: {
    listStyle: "disc inside",
    marginLeft: "16px",
    marginBottom: "6px",
  },
  li: {
    fontSize: "0.95rem",
    lineHeight: "1.7",
  },
};

const sectionTitles = [
  "Accepted Payment Methods",
  "Cash on Delivery (COD) – Premium Policy",
  "Why Advance for COD?",
  "Secure Payments",
  "Transparent Pricing",
  "Important Notes",
];

const H2 = ({ n }) => (
  <h2 style={styles.h2}>{n}. {sectionTitles[n - 1]}</h2>
);

const PaymentsPage = () => {
  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,700;1,400&family=Manrope:wght@400;500;600&display=swap"
        rel="stylesheet"
      />
      <div className="row" style={styles.ap}>
        <div className="col-xl-12" style={styles.wrap}>

          {/* HERO */}
          <section style={styles.hero}>
            <h1 style={styles.heroH1}>Payments</h1>
            <p style={styles.heroP}>Simple. Secure. Intentional.</p>
            <p style={styles.heroP}>
              At Garshya, payments are designed to be smooth, transparent, and reliable — just like everything else we do.
            </p>
            <p style={styles.heroP}>
              We offer multiple trusted payment options so you can choose what works best for you, while ensuring every transaction is safe and seamless.
            </p>
          </section>

          {/* SECTIONS */}
          <section>

            <H2 n={1} />
            <p style={styles.p}>You can complete your purchase using:</p>
            <ul style={styles.ul}>
              <li style={styles.li}><strong>UPI (Google Pay, PhonePe, Paytm, etc.)</strong></li>
              <li style={styles.li}><strong>Credit &amp; Debit Cards</strong> (Visa, Mastercard, RuPay, American Express)</li>
              <li style={styles.li}><strong>Net Banking</strong> (All major Indian banks)</li>
              <li style={styles.li}><strong>Wallets &amp; Gift Credits</strong> (where applicable)</li>
              <li style={styles.li}><strong>Cash on Delivery (COD)</strong> <em>(with conditions)</em></li>
            </ul>
            <p style={styles.p}>All payments are processed through <strong>secure and encrypted payment gateways</strong> to protect your information at every step.</p>

            <H2 n={2} />
            <p style={styles.p}>Garshya offers COD with a <strong>controlled and quality-first approach</strong>:</p>
            <ul style={styles.ul}>
              <li style={styles.li}>COD is available for orders up to <strong>₹3,000 only</strong></li>
              <li style={styles.li}>A <strong>10% advance payment is mandatory</strong> to confirm the order</li>
              <li style={styles.li}>The remaining amount is payable at the time of delivery</li>
              <li style={styles.li}>Only <strong>Indian Rupees (INR)</strong> are accepted for COD payments</li>
            </ul>
            <p style={styles.p}>This policy helps us ensure:</p>
            <ul style={styles.ul}>
              <li style={styles.li}>Genuine orders only</li>
              <li style={styles.li}>Faster processing and delivery</li>
              <li style={styles.li}>A better experience for serious buyers</li>
            </ul>

            <H2 n={3} />
            <p style={styles.p}>We believe in building a <strong>trusted ecosystem</strong>.</p>
            <p style={styles.p}>The small advance:</p>
            <ul style={styles.ul}>
              <li style={styles.li}>Confirms order authenticity</li>
              <li style={styles.li}>Reduces cancellations and delays</li>
              <li style={styles.li}>Helps us maintain a premium and reliable service</li>
            </ul>
            <p style={styles.p}>This allows us to serve customers who value <strong>quality and commitment</strong>, not just convenience.</p>

            <H2 n={4} />
            <p style={styles.p}>Your payment safety is a top priority.</p>
            <ul style={styles.ul}>
              <li style={styles.li}>All transactions are protected with <strong>industry-standard encryption</strong></li>
              <li style={styles.li}>Additional authentication (OTP / 3D Secure) may be required</li>
              <li style={styles.li}>Payments are processed via <strong>trusted banking partners</strong></li>
            </ul>
            <p style={styles.p}>We do not store your sensitive financial details on our platform.</p>

            <H2 n={5} />
            <ul style={styles.ul}>
              <li style={styles.li}>The price you see is the price you pay</li>
              <li style={styles.li}><strong>No hidden charges</strong></li>
              <li style={styles.li}>Any applicable delivery or service charges will be clearly shown before checkout</li>
            </ul>

            <H2 n={6} />
            <ul style={styles.ul}>
              <li style={styles.li}>Orders are processed only after successful payment confirmation (or COD advance)</li>
              <li style={styles.li}>In case of failed transactions, the amount (if deducted) will be refunded as per your bank's timeline</li>
              <li style={styles.li}>Garshya reserves the right to <strong>limit or disable COD</strong> for certain orders or locations based on internal checks</li>
            </ul>

            <p style={{ ...styles.p, marginTop: "16px", fontStyle: "italic" }}>
              Garshya payments aren't just about completing a transaction. They're about building trust in every step.
            </p>

          </section>
        </div>
      </div>
    </>
  );
};

export default PaymentsPage;